module.exports = require("styled-jsx/server");